import styled from 'styled-components';

const SharePageHolder = styled.div`

	.share-container {
		span {
			display: inline-block;
			color: #606060;
			font-size: 12px;
			margin-right: 10px;

			@media only screen and (max-width: 548px) {
				display: block;
    			margin-bottom: 5px;
			}
		}
		.shBtns { 
			color: white;
			border: none;
			border-radius: 4px;
			padding: 5px 10px 5px 10px;
			cursor: pointer;
			font-weight: 700;
		}
		.faBtn {
			background-color: #3c5b9a;
			&:hover {
				background-color: #2e4575;
			}
		}	
		.twBtn {
			background-color: #2aa9e0;
			margin-left: 15px;
			&:hover {
				background-color:#1b8bbc;
			}
		}
	}
`;

export default SharePageHolder;